<template>
  <a v-if="title !== '메시지'" id="sns-icon__wraps" @click="shareSns">
    <img :src="image" alt="" />
    <span>{{ title }}</span>
  </a>
  <a v-else id="sns-icon__wraps" :href="smsHref">
    <img :src="image" alt="" />
    <span>{{ title }}</span></a
  >
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    image: {
      type: String,
      default: String,
    },
    title: {
      type: String,
      default: String,
    },

    device: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      id: this.$route.query.id ? this.$route.query.id : null,
    };
  },
  computed: {
    ...mapGetters(["getObituary"]),
    smsBody() {
      return "";
    },

    checkMobile() {
      var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

      if (varUA.indexOf("android") > -1) {
        //안드로이드
        return "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1 ||
        varUA.indexOf("mac") > -1
      ) {
        //IOS
        return "ios";
      } else {
        //아이폰, 안드로이드 외
        return "other";
      }
    },

    smsHref() {
      return (
        "sms:" +
        (this.checkMobile === "ios" ? "&" : "?") +
        "body=" +
        this.smsBody
      );
    },
  },

  methods: {
    shareSns() {
      this.$emit("shareSns");
    },
  },
};
</script>

<style></style>
